import styled from 'styled-components';
import { PRIMARY_COLOR, SEMI_FONT_WEIGHT, SM_FONT_SIZE, WHITE_COLOR, XS_FONT_SIZE } from '../../Common/StyleElement';

export const PreviewContainer = styled.div`
    max-height: 250px;
    overflow-y: auto;
    border: 3px solid ${PRIMARY_COLOR};
    border-radius: 20px;
`
export const PreviewItem = styled.div`
    width: 100%;
    vertical-align: middle;
    position: relative;
    line-height: 50px;
    height: 70px;
    padding: 10px;
    text-align: left;
    > div {
        overflow: hidden;
    }

    > img {
        width: 40px;
        height: 40px;
    }
`

export const PreviewFileType = styled.div`
    display: inline-block !important;
    position: absolute;
    left: 10px;
    top: 35px;
    font-size: ${XS_FONT_SIZE};
    font-weight: ${SEMI_FONT_WEIGHT};
    line-height: 15px;
    padding: 0 4px;
    border-radius: 2px;
    box-shadow: 1px 1px 2px #abc;
    color: ${WHITE_COLOR};
    background: ${PRIMARY_COLOR};
    text-transform: uppercase;
`

export const PreviewFileName = styled.div`
    font-size: ${SM_FONT_SIZE};
    display: inline-block;
    vertical-align: top;
    margin-left: 15px;
    color: ${PRIMARY_COLOR};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 200px;
`

export const PreviewFileSize = styled.div`
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    margin-right: 5px;
    font-weight: ${SEMI_FONT_WEIGHT};
    font-size: ${XS_FONT_SIZE};
`

export const PreviewFileRemove = styled.div`
    display: inline-block;
    position: absolute;
    right: 30px;
    cursor: pointer;
`